import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from '../main-layout/main-layout.component';
import { BenefitsPlusComponent } from './components/benefits-plus/benefits-plus.component';
import { LobbyComponent } from './components/lobby/lobby.component';
import { BenefitsPopUpComponent } from './components/benefits-pop-up/benefits-pop-up.component';

const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        children: [
            {
                path: '',
                data: {
                    sessionTimeoutConfig: { sessionTimeout: true },
                    minimalHedaer: true
                },
                component: BenefitsPlusComponent,
                children: [
                    {
                        path: '',
                        component: LobbyComponent,
                        data: {
                            minimalHedaer: true
                        }
                    },
                    {
                        path: ':category/:name',
                        component: BenefitsPopUpComponent,
                        data: {
                            minimalHedaer: true
                        }
                    }
                ]
            }
        ]
    }
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BenefitsPlusRoutingModule {}
